import React, { useState, useEffect, useRef } from 'react';
import { getGuildMembers } from '../services/api';
import '../styles/UserSelect.css';

let membersCache = null;

function UserSelect({ value, onChange, required = false, label = 'Benutzer' }) {
  const [members, setMembers] = useState(membersCache || []);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(!membersCache);
  const ref = useRef();

  useEffect(() => {
    if (!membersCache) {
      getGuildMembers()
        .then(data => {
          membersCache = data;
          setMembers(data);
        })
        .catch(err => console.error('Failed to load members:', err))
        .finally(() => setLoading(false));
    }
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const filtered = members.filter(m =>
    m.displayName.toLowerCase().includes(search.toLowerCase()) ||
    m.username.toLowerCase().includes(search.toLowerCase())
  );

  const selected = members.find(m => m.id === value);

  return (
    <div className="user-select" ref={ref}>
      {label && <label>{label}{required && ' *'}</label>}
      <div
        className={`user-select-trigger ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
      >
        {selected ? (
          <div className="user-select-value">
            <img src={selected.avatar} alt="" className="user-select-avatar" />
            <span>{selected.displayName}</span>
          </div>
        ) : (
          <span className="user-select-placeholder">
            {loading ? 'Lade...' : 'Benutzer auswählen...'}
          </span>
        )}
      </div>
      {open && (
        <div className="user-select-dropdown">
          <input
            type="text"
            className="user-select-search"
            placeholder="Suchen..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
          <div className="user-select-list">
            {filtered.length === 0 ? (
              <div className="user-select-empty">Keine Benutzer gefunden</div>
            ) : (
              filtered.map(m => (
                <div
                  key={m.id}
                  className={`user-select-item ${m.id === value ? 'selected' : ''}`}
                  onClick={() => { onChange(m.id); setOpen(false); setSearch(''); }}
                >
                  <img src={m.avatar} alt="" className="user-select-avatar" />
                  <div className="user-select-info">
                    <span className="user-select-displayname">{m.displayName}</span>
                    {m.displayName !== m.username && (
                      <span className="user-select-username">@{m.username}</span>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
      {required && <input type="hidden" value={value || ''} required />}
    </div>
  );
}

export default UserSelect;
